import { render, staticRenderFns } from "./AppealsByCategoriesAndRegions.vue?vue&type=template&id=13834b8d&scoped=true&"
import script from "./AppealsByCategoriesAndRegions.vue?vue&type=script&lang=js&"
export * from "./AppealsByCategoriesAndRegions.vue?vue&type=script&lang=js&"
import style0 from "./AppealsByCategoriesAndRegions.vue?vue&type=style&index=0&id=13834b8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13834b8d",
  null
  
)

export default component.exports